import { render, staticRenderFns } from "./header-bar.vue?vue&type=template&id=96c2354e&"
import script from "./header-bar.vue?vue&type=script&lang=js&"
export * from "./header-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TritonPresentation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96c2354e')) {
      api.createRecord('96c2354e', component.options)
    } else {
      api.reload('96c2354e', component.options)
    }
    module.hot.accept("./header-bar.vue?vue&type=template&id=96c2354e&", function () {
      api.rerender('96c2354e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Scripts/app/components/header-bar/header-bar.vue"
export default component.exports